import { engineComponent, ArrayUtils } from "neo-common";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { PaylinesDefinitions } from "./PaylinesDefinitions";
import { Payline } from "./Payline";
import { Configuration } from "../Components/Configuration";
import { ComponentTypes } from "../Components/ComponentTypes";

/**
 * Paylines class is holder for all paylines.
 * Paylines define behaviour of paylines on screen.
 * @class Paylines
 * @extends ContainerElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class PaylinesSelector extends ContainerElement {
    private _paylineIDs: Array<number>;
    private _paylines: Array<Payline>;

    constructor() {
        super();

        this._paylines = [];
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    createByNode(node: Element) {
        super.createByNode(node);

        /*
         * Name of config for paylines.
         * @property Configs
         * @type string
         * @default null
         */
        if (node.hasAttribute("Configs")) {
            var configs: Array<string> = node.getAttribute("Configs").split(";");
            for (var i: number = 0; i < configs.length; i++) {
                var config: Element = Configuration.Configurations[configs[i]];
                if (config != null) {
                    this.configurate(config);
                }
            }
        }

        if (this.childs != null) {
            for (var key in this.childs) {
                if (this.childs[key] instanceof Payline) {
                    this._paylines.push(this.childs[key]);
                }
            }
        }
    }

    /**
     * Get attributes from configuration and set up supported properties.
     * @method configurate
     * @param node is Element from xml
     * @return void
     */
    configurate(node: Element): void {
        /*
         * PaylineIDs defines ids of payline used for game.
         * @property PaylineIDs
         * @type Array<number>
         * @default null
         */
        if (node.hasAttribute("PaylineIDs")) {
            this._paylineIDs = ArrayUtils.numberArray(node.getAttribute("PaylineIDs"));
        }
    }

    /**
     * Reset all paylines to case NORMAL.
     * @method reset
     * @return void
     */
    reset(): void {
        this.visible = false;
        for (var i: number = 0; i < this._paylines.length; i++) {
            this._paylines[i].goToCase(Payline.CaseNormal);
        }
    }

    select(id?: number): void {
        this.visible = true;

        // for (var i: number = 0; i < this._paylines.length; i++) {
        this._paylines[id / 20 - 1].goToCase(Payline.CaseSelect);
        // }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/PaylinesSelector.ts
 **/